import { render, staticRenderFns } from "./CardContactDetails.vue?vue&type=template&id=62495e78"
import script from "./CardContactDetails.vue?vue&type=script&lang=js"
export * from "./CardContactDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports